// extracted by mini-css-extract-plugin
export var label = "_rp-0";
export var link = "_rp-1";